module.exports = __webpack_public_path__ + "static/media/ic-nav-exhibitors.8fa5d579.svg";